import detail from './detail'
import playlist from './playlist'
import record from './record'

export default {
  detail, // 获取用户详情
  playlist, // 获取用户歌单
  record // 获取用户播放记录
}
